import React, { useState, useEffect } from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import moment from "moment";

import Dialog from "../common/dialog";
import AppTheme from "../AppTheme";
import ManaButton from "../common/ManaButton";
import ManaCalendarIcon from "../common/icons/ManaCalendarIcon";
import style from "../common/calendar/header/style";

export default function TrackWarningDialog({
  data,
  goToToday = () => {},
  confirm = () => {},
  close = () => {},
}) {
  const [timeslot, setTimeslot] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [isIntheFuture, setIsIntheFuture] = useState(false);

  useEffect(() => {
    const ts = data.timeslot || data; // predictions vs activity

    const tsDate = moment(ts.time);
    setSelectedDate(tsDate.format("MMM DD"));

    setIsIntheFuture(data.timelineDays > 0);
    setTimeslot(ts);
  }, [data]);

  return (
    <Dialog.Container
      onClose={close}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        paddingTop: 0,
        marginTop: 0,
        paddingBottom: 12,
        paddingHorizontal: 12,
      }}
    >
      <View style={[styles.header]}>
        <ManaCalendarIcon style={styles.calendarIcon} />

        <View style={styles.headerInfo}>
          <Text style={styles.title}>
            Did you mean to track {isIntheFuture ? "future" : "past"} time?
          </Text>
          <View style={styles.row}>
            <Text style={styles.date}>{selectedDate}</Text>
            {timeslot.startTime && timeslot.endTime ? (
              <Text style={styles.date}>
                &nbsp;•&nbsp;{timeslot.startTime} - {timeslot.endTime}
              </Text>
            ) : null}
          </View>
        </View>
      </View>

      <View style={styles.buttons}>
        <ManaButton
          style={[styles.button]}
          styleText={styles.buttonText}
          text={`No, take me to today`}
          onPress={goToToday}
        />

        <ManaButton
          isMainButton
          style={[styles.button]}
          styleText={styles.buttonText}
          text="Yes, continue"
          onPress={confirm}
        />
      </View>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    height: 100,
  },
  picker: {
    borderWidth: 1,
    borderColor: "#000",
    borderRadius: 4,
    height: 40,
  },
  header: {
    height: 40,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  headerInfo: {
    height: "100%",
    flex: 1,
    display: "flex",
    justifyContent: "center",
    paddingTop: 12,
  },
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },

  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    zIndex: 2,
  },
  date: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Medium",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0,
    color: AppTheme.almostBlack,
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    marginTop: 8,
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 148,
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0,
  },
  calendarIcon: {
    width: 18,
    height: 18,
    marginRight: 8,
  },
});
